﻿(function() {
  function trackEvent(e, action) {
    var category = jQuery('#_gaCategory').val();
    var labelPrefix = jQuery('#_gaLabelPrefix').val();
    var parentPageUrl = jQuery('#hdnParentPageURL').val();
    if (!labelPrefix) {
      labelPrefix = '';
    }
      var pagePath = action.toLowerCase() === 'view' ? window.location.pathname : parentPageUrl;
      if (typeof (ga) !== 'undefined') {
          ga('send', 'event', '' + category + '', '' + action + '', '' + pagePath + '');
      }
  };

  function init() {

    if (typeof $$epiforms !== "undefined") {
      trackEvent(this, 'view');
    }

  };

  $(document).ready(init);
})();